"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendGiphySDKRequestParam = exports.appendGiphySDKRequestHeader = exports.getGiphySDKRequestHeaders = void 0;
var gl = ((typeof window !== 'undefined' ? window : global) || {});
// define _GIPHY_SDK_HEADERS_ if they don't exist
gl._GIPHY_SDK_HEADERS_ =
    gl._GIPHY_SDK_HEADERS_ ||
        (gl.Headers
            ? new gl.Headers({
                'X-GIPHY-SDK-PLATFORM': 'web',
            })
            : undefined);
exports.getGiphySDKRequestHeaders = function () { return gl._GIPHY_SDK_HEADERS_; };
exports.appendGiphySDKRequestHeader = function (key, value) { var _a; return (_a = exports.getGiphySDKRequestHeaders()) === null || _a === void 0 ? void 0 : _a.set(key, value); };
exports.appendGiphySDKRequestParam = function (key, value) { var _a; return (_a = exports.getGiphySDKRequestHeaders()) === null || _a === void 0 ? void 0 : _a.set(key, value); };
//# sourceMappingURL=sdk-headers.js.map